import axios from "axios";
import settings from "../settings";
let initialState = {
    loadingSalesInvoiceList: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    salesInvoices: [],
    invoicesListItems: [],
    errorMessage: ""
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getSalesInvoices({ commit }, payload) {
            commit("setSalesInvoiceListLoading", true);
            try {
                let params = {
                    start_date: payload.start_date,
                    end_date: payload.end_date
                };
                let response = await axios.get(settings.api_url + "/sale-invoice/", { params });
                let data = response.data;
                if (data.success === 1) commit("addSalesInvoices", data.sales_invoices);
                commit("setSalesInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setSalesInvoiceListLoading", false);
            }
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addSalesInvoices(state, salesInvoices) {
            state.salesInvoices = salesInvoices;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setSalesInvoiceListLoading(state, value) {
            state.loadingSalesInvoiceList = value;
        },
        updateInvoicesList(state, value) {
            state.invoicesListItems = state.salesInvoices.filter(invoice => invoice.customer_country === value);
        }
    },
    getters: {
        salesInvoicesCount: state => {
            return state.salesInvoices.length;
        }
    }
};
